module.exports = __webpack_public_path__ + "img/vertical_6_5_3016.0b1f857b.png";